@import '@hevoio/hevo-ui-toolkit/styles/variables';
@import '@hevoio/hevo-ui-toolkit/styles/typography/typography-utils';

.dialogBody {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: $spacer * 1.5;
}

.confirmationTitle {
  @include typography-level-to-styles(typography-config(), subheading-3);
  text-align: center;
}

.confirmationBody {
  @include typography-level-to-styles(typography-config(), body-1);
  text-align: center;
  margin-top: $spacer * .5;
}

.confirmationSubText {
  text-align: center;
  margin-top: $spacer * .5;
}
